import { Field, useField } from 'formik';
import React from 'react';
import { Col, Row } from 'react-bootstrap';

import { AutocompleteOption } from '../../utils/interfaces';

interface RadioButtonGroupProps {
  label?: string;
  name: string;
  options: AutocompleteOption[];
  size?: string;
}

/**
 * @param {{name, label, options, ...}} props
 * options => [{label: "label 1", value: 1}, {label: "label 2", value: 2}, ...]
 * where label is displayed, and value is an optional value attached for the item.
 */

const RadioButtonGroup = (props: RadioButtonGroupProps) => {
  const { label, name, options, size } = props;
  const [field, meta, helpers] = useField(name);

  const handleOnChange = (RadioBtnKey) => {
    helpers.setValue(RadioBtnKey);
  };

  return (
    <div className="RadioButtonGroup form-group">
      {label && (
        <label className="input-label" htmlFor={name} id="radio-button-label">
          {label}
        </label>
      )}
      {options.map((el) => {
        return (
          <Row
            key={el.value}
            className={`radiobutton-group-option ${meta.touched && meta.error ? 'is-invalid' : ''}`}
          >
            <Col xs={12}>
              <label className={`radiobutton-container ${size === 'large' ? ' --large' : ''}`}>
                <Field
                  type="radio"
                  className="radio-input"
                  name={name}
                  id={el.value}
                  value={el.value}
                  checked={field.value === el.value}
                  onChange={() => handleOnChange(el.value)}
                />
                <span className="radiobutton-text">{el.label}</span>
              </label>
            </Col>
          </Row>
        );
      })}
      {meta.touched && meta.error && <div className="invalid-feedback">{meta.error}</div>}
    </div>
  );
};

export default RadioButtonGroup;
